import { Badge } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import RemoveUserAccessGroup from '../elements/RemoveUserAccessGroup';
import { NamePill } from './NamePill';
import EditUserAccessGroup from './elements/EditUserAccessGroup';
import { roleRank } from './elements/roles';
import type { AccessGroupMemberProps } from './elements/types/accessGroupMemberProps';

export const AccessGroupMember = ({
  member,
  accessGroup,
  removeUser,
  removeUserLoading,
  allRoles,
  canAssignSuperAdmin,
  onSubmit,
  loading,
  disableEditUser,
  disableRemoveUser,
}: AccessGroupMemberProps) => {
  const { t } = useTranslation();
  return (
    <div className="border border-gray-200 border-t-0 mx-1 px-4 py-2 flex justify-between">
      <div className="flex items-center px-4">
        <div className="mr-2 my-0 pr-2">
          <NamePill firstName={member.firstName} lastName={member.lastName} />
        </div>
        <div className="access-group-member-name mr-1">
          {member.firstName} {member.lastName}
        </div>
        <div className="flex flex-wrap">
          {member.roles.map((x) => (
            <span key={x.id} style={{ marginRight: '6px' }}>
              <Badge variant="soft" color="indigo" radius="large">
                {roleRank(x.key) >= 0 ? t(`settings.accessGroupRoles.${x.key}.name`) : x.name}
              </Badge>
            </span>
          ))}
        </div>
      </div>
      <div className={'w-1/4 flex flex-row justify-end gap-3'}>
        <EditUserAccessGroup
          user={member}
          accessGroup={accessGroup}
          onSubmit={onSubmit}
          userLoading={loading}
          allRoles={allRoles}
          canAssignSuperAdmin={canAssignSuperAdmin}
          disable={disableEditUser}
        />
        <RemoveUserAccessGroup
          user={member}
          accessGroup={accessGroup}
          onSubmit={removeUser}
          loading={removeUserLoading}
          disable={disableRemoveUser}
          disabledReason={
            member.isSuperAgAdmin && !canAssignSuperAdmin
              ? t('settings.accessGroupDialogs.removeUserAccessGroup.superAdminTooltip')
              : undefined
          }
        />
      </div>
    </div>
  );
};
